var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" bg-brand-secondary min-h-full"},[_c('div',{staticClass:"max-w-6xl mx-auto"},[_c('NavRow'),_c('div',[_vm._v(" Temp Sites Created on this machine. ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }